import * as pubsub from "pubsub-js";
import { AppType } from "client/Api/Apps/common";

enum AppStoreEvent {
	// When 1 app became enabled
	AppEnabled = "appStore.app.enabled",
	// When 1 app became disabled
	AppDisabled = "appStore.app.disabled"
}

type Data<T extends AppStoreEvent> =
	T extends AppStoreEvent.AppEnabled ? { id: number; type: AppType; } :
	T extends AppStoreEvent.AppDisabled ? { id: number; type: AppType; } :
	never;

export const subscribe: <T extends AppStoreEvent>(kind: T, callback: (message: string, data: Data<T>) => void) => PubSubSubscriptionToken = pubsub.subscribe;
export const publish: <T extends AppStoreEvent>(kind: T, data: Data<T>) => void = pubsub.publish;
export const unsubscribe: (token: PubSubSubscriptionToken) => void = pubsub.unsubscribe;
export {
	AppStoreEvent
};
